/*
 * Copyright (c) 2018 Barclays PLC.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Barclays PLC.
 * ("Confidential Information").
 *
 * File: bankMarketCheckYourRatePage.js
 * Created: Nov 28, 2018
 */

import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { parseQueryString } from "../../../utils/formatters";
import { marketCodeChanged } from "../../../actions";
import { fetchCustomerInfoFromToken, fetchUpdatedCampaignData, fetchCustomerInfoFromTokenWithCallback } from "../../../actions/loanApplicationActions";
import { getLoanApplication, getCampaignFromEnvConfig } from "../../../selectors";
import { MarketCodes } from "../../../marketCodes";
import ProgressBar from '../../progress.bar';
import Section from '../../Section/section';
import { isEmpty } from 'ramda';
import CheckYourRateForm from "../../LoanApplication/CheckYourRateForm/checkYourRateForm";
import LoanApplicationHeader from '../../LoanApplication/LoanApplicationHeader/loanApplicationHeader';
import Footer from "../../Footer/footer";
import FeatureToggle from '../../FeatureToggle/feature.toggle';
import moneyFormatter from 'money-formatter';

export class BankMarketCheckYourRatePage extends React.Component {

    fetchUpdatedCampaignDataCallback = () => {
      this.props.fetchUpdatedCampaignData();
    };

    componentWillMount() {
      this.props.marketCodeChanged(MarketCodes.BANK_MARKET);
      if(window.isToggleOn('cl_aprnote_and_disclosure_links_on_bm_cyrpage')) {
        this.props.fetchCustomerInfoFromTokenWithCallback(parseQueryString(this.props.location.search).offerId, this.fetchUpdatedCampaignDataCallback);
      } else {
        this.props.fetchCustomerInfoFromToken(parseQueryString(this.props.location.search).offerId);
      }
    }

  render = () => {
    const { loanApplication, campaign } = this.props;
    const disclosureUrl = `/clapply/cl/CLCyr.action?offerTermsAndDisclosures&minApr=${campaign.minApr}&maxApr=${campaign.maxApr}&minLoanAmount=${moneyFormatter.format('USD', campaign.minLoanAmount, 0)}&maxLoanAmount=${moneyFormatter.format('USD', campaign.maxLoanAmount, 0)}`;

    return isEmpty(loanApplication) ?
      (<article/>) :
      (<article className="bmMiniAppFooter">
        <LoanApplicationHeader title={`Nice to see you, ${loanApplication.firstName}`}>
          <ul>
            <h2/>
            <li>
              <p>We just need a bit more information.</p>
            </li>
          </ul>
        </LoanApplicationHeader>
        <Section>
          <header>
            <ProgressBar step="miniApp"/>
            <p className="font-weight-normal">Please fill in the fields below.</p>
          </header>
          <CheckYourRateForm/>
          <FeatureToggle featureName="cl_aprnote_and_disclosure_links_on_bm_cyrpage">
            <section className="col-12">
              <p>
                <a href={disclosureUrl} data-track="app-links" target="_blank" className="text-muted">Offer Terms & Other Disclosures</a>
              </p>
            </section>
            <br/>
            <Footer
              hideFooterIcons={true}
              hideBankName={true} />
          </FeatureToggle>
        </Section>
      </article>);
  }
}

const mapStateToProps = (state) => ({
  loanApplication: getLoanApplication(state),
  campaign: getCampaignFromEnvConfig(state)
});

const mapDispatchToProps = {
  fetchCustomerInfoFromToken, marketCodeChanged, fetchUpdatedCampaignData, fetchCustomerInfoFromTokenWithCallback
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BankMarketCheckYourRatePage));
